class APIS {
	apis() {
		return {
			add: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/ai/call/provider/add'
			},
			all: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/ai/call/provider/all'
			},
			detail: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/ai/call/provider/detail'
			},
			update: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/ai/call/provider/update'
			},
			toggle: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/ai/call/provider/toggle'
			}
		};
	}
}

export default new APIS();
